"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePayload;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function generatePayload(searchType, searchState) {
  var isMmfa = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (searchType === 'agent') {
    return {
      searchby: searchState.searchByName === false ? 'coordinates' : 'name',
      latitude: searchState.searchByName === false ? searchState.lat : 0,
      longitude: searchState.searchByName === false ? searchState.lng : 0,
      dist: searchState.distanceMiles,
      searchterm: searchState.searchByName === true ? searchState.nameOrZipCodeInputSelection : '',
      specialty: searchState.specialtySelection ? searchState.specialtySelection.map(selection => selection.label).join(',') : '',
      languages: searchState.languageSelection ? searchState.languageSelection.map(selection => selection.label).join(',') : '',
      upperlat: searchState.upperlat ? searchState.upperlat : 0,
      upperlon: searchState.upperlng ? searchState.upperlng : 0,
      nextavailabledistsearch: !searchState.disableNextAvailableDistSearch
    };
  } else if (searchType === 'agency') {
    return _objectSpread(_objectSpread({
      searchby: searchState.searchByName === false ? 'coordinates' : 'name',
      latitude: searchState.searchByName === false ? searchState.lat : 0,
      longitude: searchState.searchByName === false ? searchState.lng : 0,
      dist: searchState.distanceMiles,
      searchterm: searchState.searchByName === true ? searchState.nameOrZipCodeInputSelection : '',
      specialty: searchState.specialtySelection ? searchState.specialtySelection.map(selection => selection.label).join(',') : '',
      languages: searchState.languageSelection ? searchState.languageSelection.map(selection => selection.label).join(',') : '',
      upperlat: searchState.upperlat ? searchState.upperlat : 0,
      upperlon: searchState.upperlng ? searchState.upperlng : 0,
      checkshowoncareer: !!isMmfa
    }, isMmfa && {
      sortby: 'dist'
    }), {}, {
      nextavailabledistsearch: !searchState.disableNextAvailableDistSearch
    });
  }
  return null;
}